module.exports = __webpack_public_path__ + "img/president_message.f9a0825.png";